function isInShadow(node) {
  if (!node) {
    return false;
  }
  return node.getRootNode() instanceof ShadowRoot;
}
function getFirstShadowElement(node) {
  if (!node || !isInShadow(node)) {
    return;
  }
  const shadowRoot = node == null ? void 0 : node.getRootNode();
  const firstElementChild = Array.from(shadowRoot.children).find((el) => el.tagName !== "STYLE");
  return firstElementChild;
}
export {
  getFirstShadowElement,
  isInShadow
};
//# sourceMappingURL=shadowDom3.js.map
